'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Iframe, Root } from './MIframe.styles';
export const MIframe = ({ desktopHeight, desktopWidth, layout, mobileHeight, mobileWidth, src, title })=>/*#__PURE__*/ _jsx(Root, {
        $desktopHeight: desktopHeight ? Number(desktopHeight) : 900,
        $desktopWidth: desktopWidth ? Number(desktopWidth) : 1600,
        $layout: layout ?? 'responsive',
        $mobileHeight: mobileHeight ? Number(mobileHeight) : 600,
        $mobileWidth: mobileWidth ? Number(mobileWidth) : 400,
        "data-testid": "iframe",
        children: /*#__PURE__*/ _jsx(Iframe, {
            allow: "geolocation",
            height: "100%",
            loading: "lazy",
            src: src ?? '',
            title: title ?? '',
            width: "100%"
        })
    });

//# sourceMappingURL=MIframe.js.map